import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = useCallback(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
    api.get("/notifications/unread-count").then((r) => setUnread(r.data.count)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <Popover onOpenChange={(o) => { if (o && unread > 0) markAll(); }}>
      <PopoverTrigger asChild>
        <button data-testid="notif-bell" className="relative flex h-9 w-9 items-center justify-center rounded-md hover:bg-secondary">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notif-count" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notif-panel">
        <div className="border-b border-border px-4 py-3 font-display font-bold">Notifikasi</div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <p className="px-4 py-6 text-center text-sm text-muted-foreground">Belum ada notifikasi.</p>}
          {items.map((n) => (
            <div key={n.id} className={`border-b border-border px-4 py-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="text-sm font-semibold">{n.title}</div>
              <div className="text-xs text-muted-foreground">{n.message}</div>
              <div className="mt-1 font-mono-terminal text-[10px] text-muted-foreground">{new Date(n.created_at).toLocaleString("id-ID")}</div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
